import _ from 'lodash';
import axios from 'axios';
import DataProvider from "../../../app/data-framework/data-provider";
import LoginService from "../../../services/login.service";

var CACHE_KEYS = {
    ADD_CPMA_DATASET_METADATA: 'ADD_CPMA_DATASET_METADATA',
    DATASET_METADATA: 'DATASET_METADATA',
    METRICS_METADATA: 'METRICS_METADATA',
    CALL_RECORDS_METADATA: 'CALL_RECORDS_METADATA',
    DATA_SOURCES_METADATA: 'DATA_SOURCES_METADATA',
    METRIC_ID_MIGRATION: 'METRIC_ID_MIGRATION'
};

var instance = null;

function DataService() {
    if (instance !== null) {
        throw new Error('Cannot instantiate more than one DataService. Call DataService.getInstance() instead.');
    }
    var self = this;
    self.clearCache.call(self);
}

function fetchJsonFile(self, fileId, url, filter) {
    var config = _.get(self.cache, fileId);
    if (_.isEmpty(config)) {
      return axios.get(url, {
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then(response => {
        if (filter) {
            response.data = filter(response.data);
        }
        _.set(self.cache, fileId, response.data);
        return response.data;
      });
    } else {
        return Promise.resolve(config);
    }
}

DataService.prototype = {
    dispose: function() {
        var self = this;
        self.clearCache();
    },

    clearCache: function () {
        var self = this;
        self.cache = {};
        self.preferences = null;
    },

//  DATASETS & METRICS

    fetchAddCpmaDatasetMetadata: function () {
        var self = this;
        return fetchJsonFile(self, CACHE_KEYS.ADD_CPMA_DATASET_METADATA, 'dist/metadata/add_cpma_datasets_metadata.json?bust=' + GLOBAL_VERSION);
    },

    fetchDatasetMetadata: function () {
        var self = this;
        return fetchJsonFile(self, CACHE_KEYS.DATASET_METADATA, 'dist/metadata/datasets_metadata.json?bust=' + GLOBAL_VERSION);
    },

    fetchMetricModelsCache: function () {
        var self = this;
        var cacheKey = 'GetMetricModels';
        var models = _.get(self.cache, cacheKey);
        return models;
    },

    cacheMetricModels: function (response) {
        var self = this;
        var cacheKey = 'GetMetricModels';
        _.set(self.cache, cacheKey, response);
    },


    fetchEndpointTagsCache: function () {
        var self = this;
        var endpoint = 'GetEndpointTags';
        var tags = _.get(self.cache, endpoint);
        return tags;
    },

    cacheEndpointTags: function (response) {
        var self = this;
        var endpoint = 'GetEndpointTags';
        _.set(self.cache, endpoint, response);
    },

    fetchMetricsMetadata: function () {
        var self = this;
        return fetchJsonFile(self, CACHE_KEYS.METRICS_METADATA, 'dist/metadata/metrics_metadata.json?bust=' + GLOBAL_VERSION, (data) => {
            if (data) {
                data.forEach((category) => {
                    category.filterOptions = category.filterOptions.filter((opt) => {
                        return !opt.optIn || DataProvider.getInstance().isInternalUser() || LoginService.userObject.featureFlags[opt.optIn];
                    });
                });
            }
            return data;
        });
    },

    fetchMetricsIdMigration: function (metricMetadata) {
        var self = this;
        var migrationData = _.get(self.cache, CACHE_KEYS.METRIC_ID_MIGRATION, {});
        function loadMigrationData(metrics) {
            _.forEach(metrics, metric => {
                if (metric.oldId) {
                    if (!migrationData[metric.oldId]) {
                        migrationData[metric.oldId] = metric.id;
                    }
                }
            });
        }
        if (_.isEmpty(migrationData)) {
            _.forEach(metricMetadata, category => {
                loadMigrationData(category.metrics, migrationData);
                if (category.models) {
                    _.forEach(category.models, model => {
                        loadMigrationData(model.metrics, migrationData);
                    });
                }
            });
            _.set(self.cache, CACHE_KEYS.METRIC_ID_MIGRATION, migrationData);
        }
        return migrationData;
    },

    fetchCallRecordsMetadata: function () {
        var self = this;
        return fetchJsonFile(self, CACHE_KEYS.CALL_RECORDS_METADATA, 'dist/metadata/call_record_metadata.json?bust=' + GLOBAL_VERSION);
    },

    fetchDataSourcesMetadata: function () {
        var self = this;
        return fetchJsonFile(self, CACHE_KEYS.DATA_SOURCES_METADATA, 'dist/metadata/data_sources_metadata.json?bust=' + GLOBAL_VERSION);
    }
};

DataService.getInstance = function() {
    if (instance === null) {
        instance = new DataService();
    }
    return instance;
};

export default DataService.getInstance();
